export const ShipmentInProcessContract  = {
    async external_shipments_index() {
        throw new Error("external_shipments_index_shipment_in_process not implemented");
    }
}